/**
 * Per-pixel operations a brush stamp can perform instead of laying down colour.
 * Ids must match the `FILTER_*` defines in `strokeFilter.frag.glsl`.
 */
export type PaintFilter = 'blur' | 'sharpen' | 'dodge' | 'burn' | 'sponge' | 'clone';

export const PAINT_FILTER_IDS: Record<PaintFilter, number> = {
  blur: 0,
  sharpen: 1,
  dodge: 2,
  burn: 3,
  sponge: 4,
  clone: 5,
};

/** Tonal band Dodge and Burn act on. Ids match `RANGE_*` in the same shader. */
export type ToneRange = 'shadows' | 'midtones' | 'highlights';

export const TONE_RANGE_IDS: Record<ToneRange, number> = {
  shadows: 0,
  midtones: 1,
  highlights: 2,
};

export const TONE_RANGE_LABELS: Record<ToneRange, string> = {
  shadows: 'Shadows',
  midtones: 'Midtones',
  highlights: 'Highlights',
};
